$ = jQuery

$.fn.extend
  star_rating_input: (command) ->
    star_selector = '.star-rating'

    reset = =>
      return @each ->
        $(@).val('').change()
        changeStarsTo 0

    changeStarsTo = (rating) =>
      $(@).siblings(star_selector).children('i').each (i, star) ->
        if i < rating
          $(star).addClass('fa-star').removeClass('fa-star-o')
        else
          $(star).addClass('fa-star-o').removeClass('fa-star')

    ratingFromMousePosition = (e) =>
      $el = $(@).siblings(star_selector)
      Math.ceil((((e.pageX - $el.offset().left) / $el.width()) * 100) / 20)

    init = =>
      @each ->
        $(@).siblings(star_selector).on 'mousemove', (e) =>
          changeStarsTo ratingFromMousePosition(e)

        $(@).siblings(star_selector).on 'mouseleave', (e) =>
          rating = $(@).val()
          rating = 0 if rating is ''
          changeStarsTo rating

        $(@).siblings(star_selector).on 'click', (e) =>
          rating = ratingFromMousePosition(e)
          rating = '' if rating is 0
          $(@).val(rating).change()

    switch command
      when 'reset' then reset()
      else init()
